module.exports = __webpack_public_path__ + "static/media/2.00a68546.jpg";